/*
Replace
nft with your resource Name :) Take care about different writings!
/!\ Nft nft Nfts nfts /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const projectDesignsSlice = createSlice({
  name: "projectDesigns",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
    updateErrorReset: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = null;
    },
    listErrorReset: (state, action) => {
      state.listing = false;
      state.listed = false;
      state.listError = null;
    },
    createErrorReset: (state, action) => {
      state.creating = false;
      state.created = false;
      state.createError = null;
    },
    showErrorReset: (state, action) => {
      state.showing = false;
      state.showed = false;
      state.showError = null;
      state.unlockError = null;
      state.unlockSuccess = false;
    },
  },
});

export const {
  show: showProjectDesign,
  update: updateProjectDesign,
  list: listProjectDesigns,
  create: createProjectDesign,
  updateErrorReset: updateProjectDesignErrorReset,
  listErrorReset: listProjectDesignErrorReset,
  createErrorReset: createProjectDesignErrorReset,
  showErrorReset: showProjectDesignErrorReset,
} = projectDesignsSlice.actions;
export const actions = projectDesignsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const projectDesigns = (state) =>
  state.projectDesigns.idsList.map(
    (id) => state.projectDesigns.dictionary[id]
  );
export const projectDesign = (state) =>
  state.projectDesigns.showId &&
  state.projectDesigns.dictionary[state.projectDesigns.showId];
export const projectDesignAttributes = (state) =>
  projectDesign(state)?.attributes;
export const projectDesignRelationships = (state) =>
  projectDesign(state)?.relationships;
export const projectDesignId = (state) => state.projectDesigns.showId;

export const getProjectDesign = createSelector(
  (state) => state.projectDesigns.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getProjectDesignAttributes = createSelector(
  (state) => state.projectDesigns.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getProjectDesignRelationships = createSelector(
  (state) => state.projectDesigns.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getProjectDesigns = createSelector(
  (state) => state.projectDesigns.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default projectDesignsSlice.reducer;
